module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4>\n  Week\n  <input type="number" value="'+
((__t=( week ))==null?'':_.escape(__t))+
'" class="weekNo textfield" min="0"\n    step="1" pattern="^[0-9]+$" />\n  <a class="button remove-week" href="#">\n    <img src="/static/images/icon-trash.gif" />\n  </a>\n</h4>\n<table class="week datatable">\n  <thead>\n  </thead>\n  <tbody class="content">\n\n  </tbody>\n  <tr>\n    <th colspan="8" class="new">\n      New Choice <span class="icon icon-plus">+</span>\n    </th>\n  </tr>\n</table>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./menupicker/templates/week.html
// module id = 270
// module chunks = 0